<template>
  <layout-workflow>
    <template #subheader>
      <PrivacyHeader />
    </template>
    <template #default>
      <div class="ma-4">
        <app-pdf :file-url="'/privacy.pdf'" />
      </div>
    </template>
  </layout-workflow>
</template>

<script>
import LayoutWorkflow from '@/components/layout/LayoutWorkflow'
import PrivacyHeader from '@/components/support/PrivacyHeader'

export default {
  components: { PrivacyHeader, LayoutWorkflow }
}
</script>
